import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import { Button } from "@radix-ui/themes";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { FC, useCallback } from "react";
import { useParams } from "react-router";

export const AccountTransitionInfoViewPage: FC = () => {
  const queryClient = useQueryClient();
  const { accountTransitionInfoId } = useParams<{ accountTransitionInfoId: Uuid }>();

  if (!accountTransitionInfoId) {
    return <div>Invalid ID</div>;
  }

  const result = useQuery({
    queryKey: ["account-transition-info-by-id", accountTransitionInfoId],
    queryFn: () =>
      api.get("/internal/v1/account-transition-info/{account_transition_info_id}", {
        params: {
          path: {
            account_transition_info_id: accountTransitionInfoId,
          },
        },
      }),
  });

  const patchAccountTransitionInfo = useCallback(
    async ({
      forceUpgradedToVersionTwo,
      versionTwoTransitionDecisionRequired,
    }: {
      forceUpgradedToVersionTwo?: boolean;
      versionTwoTransitionDecisionRequired?: boolean;
    }) => {
      const confirmed = confirm(
        `Are you sure you want to patch account transition info with the following values: ${JSON.stringify(
          {
            forceUpgradedToVersionTwo,
            versionTwoTransitionDecisionRequired,
          }
        )}?`
      );

      if (!confirmed) {
        return;
      }

      await api.patch("/internal/v1/account-transition-info/{account_transition_info_id}", {
        params: {
          path: {
            account_transition_info_id: accountTransitionInfoId,
          },
        },
        body: {
          force_upgraded_to_version_two: forceUpgradedToVersionTwo,
          version_two_transition_decision_required: versionTwoTransitionDecisionRequired,
        },
      });

      await queryClient.invalidateQueries({
        queryKey: ["account-transition-info-by-id", accountTransitionInfoId],
      });
    },
    [accountTransitionInfoId]
  );

  const markForceUpgradeRequiredAsTrue = useCallback(() => {
    patchAccountTransitionInfo({
      forceUpgradedToVersionTwo: true,
    });
  }, [patchAccountTransitionInfo]);

  const markForceUpgradeRequiredAsFalse = useCallback(() => {
    patchAccountTransitionInfo({
      forceUpgradedToVersionTwo: false,
    });
  }, [patchAccountTransitionInfo]);

  const markVersionTwoTransitionDecisionRequiredAsTrue = useCallback(() => {
    patchAccountTransitionInfo({
      versionTwoTransitionDecisionRequired: true,
    });
  }, [patchAccountTransitionInfo]);

  const markVersionTwoTransitionDecisionRequiredAsFalse = useCallback(() => {
    patchAccountTransitionInfo({
      versionTwoTransitionDecisionRequired: false,
    });
  }, [patchAccountTransitionInfo]);

  return (
    <div>
      <h1>View Account Transition Info</h1>

      <Button variant="outline" onClick={markForceUpgradeRequiredAsTrue}>
        Mark Force Upgrade Required as True
      </Button>
      <br />
      <Button variant="outline" onClick={markForceUpgradeRequiredAsFalse}>
        Mark Force Upgrade Required as False
      </Button>
      <br />
      <Button variant="outline" onClick={markVersionTwoTransitionDecisionRequiredAsTrue}>
        Mark Version Two Transition Decision Required as True
      </Button>
      <br />
      <Button variant="outline" onClick={markVersionTwoTransitionDecisionRequiredAsFalse}>
        Mark Version Two Transition Decision Required as False
      </Button>
      <br />
      <br />
      <br />
      <pre>{JSON.stringify(result.data, null, 2)}</pre>
    </div>
  );
};
